<template>
    <div class="section-group">
        <div class="checkbox-options">
            <div class="checkbox-option" v-for="option in options" :key="option.id">
                <input
                    type="radio"
                    :id="`${fieldName}-${option.id}`"
                    :name="fieldName"
                    :readonly="readonly"
                    :disabled="readonly"
                    :checked="option.id === value"
                    :value="option.id"
                    @change="updateValue(option.id)"
                />

                <label :for="`${fieldName}-${option.id}`">{{ option.label }}</label>

                <slot v-if="option.id === value" :name="option.id" />
            </div>
        </div>
    </div>
</template>

<script>
// Example Usage:
// <dealer-agreement-form-field-radio fieldName="field" />

export default {
    name: 'dealer-agreement-form-field-radio',

    model: {
        event: 'change',
    },

    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },

        fieldName: {
            type: String,
            required: true,
        },

        value: {
            type: [String, Number, Boolean, Object],
            required: false,
        },

        options: {
            type: Array,
            required: false,
            default: () => [],
        },

        readonly: {
            type: Boolean,
            default: true,
        },
    },

    methods: {
        updateValue(value) {
            this.$emit('change', value);
        },
    },
};
</script>
